/**
 * @prettier
 */
import _isUuid from 'uuid-validate';

export function isUuid(value?: any | null): boolean {
    return _isUuid(value, 4);
}
